export const ogrzewanieData = {
    order: 7,
    name: 'ogrzewanie',
    title: 'Ogrzewanie',
    iconSrc: 'pic_ogrzewanie.svg',
    headlineText:
        'Istnieje wiele działań, dzięki którym ogrzewanie domu przestanie być sporym wydatkiem, a smog problemem.  Akcja modernizacja!',
    mainText:
        'Większość wytwarzanej w Polsce energii pochodzi z paliw kopalnych – węgla, ropy i gazu, których spalanie uwalnia olbrzymie ilości dwutlenku węgla. Wyprodukowanie 1 kWh energii z węgla to emisja 1kg CO2, dla ropy to już niecałe 70 dkg CO2, a dla gazu poniżej 40 dkg CO2. Do tego dochodzą zanieczyszczenia pyłowe i gazowe, których zdecydowanie najwięcej emitują przestarzałe kotły węglowe, tzw. kopciuchy. Efektem są coroczne zmagania ze smogiem i fatalne statystyki jakości powietrza w sezonie grzewczym. Niska emisja jest źródłem aż 84% całkowitej emisji rakotwórczego benzo(a)pirenu oraz 86% emisji pyłu zawieszonego PM10. Skoro aż 70% energii w naszych domach wykorzystujemy do ich ogrzania, jak to zrobić, aby było nie tylko ekologicznie, ale i ekonomicznie?',
    mainVideoSrc:
        '<iframe width="560" height="315" src="https://www.youtube-nocookie.com/embed/nTAtgR_Mruo" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>',
    odpadySection: [],
    klimatSection: [],
    energiaSection: [
        {
            text:
                'Unikaj przegrzewania pomieszczeń. Optymalna temperatura w salonie to około 21-22 stopnie, a w sypialni nawet nieco niższa. Pamiętaj, że podniesienie temperatury o każdy dodatkowy stopień to sporo więcej paliwa potrzebnego do ogrzania powierzchni.',
        },
        {
            text:
                'Automatyczne sterowanie pracą kotła pozwala na dostosowanie obciążenia, czasu pracy urządzenia i temperatury do naszych preferencji. Osiągniemy w ten sposób komfort cieplny, a jednocześnie zaoszczędzimy na paliwie.',
        },
        {
            text:
                'Nie wietrz mieszkania przy odkręconych grzejnikach. Gdy już wietrzysz, nie zostawiaj okna otwartego zbyt długo.',
        },
        {
            text: 'Sprawdź szczelność okien! Przez nie również ucieka ciepło – nawet 15% - 25%.',
        },
        {
            text:
                'Nie zastawiaj meblami grzejników lub kaloryferów – blokujesz w ten sposób rozchodzenie się ciepła w pomieszczeniu.',
        },
        {
            text:
                'Odpowiednio docieplony budynek będzie potrzebował nawet dwa razy mniej energii do jego ogrzania, dlatego zastanów się nad inwestycją w termomodernizację domu. Przez nieocieplone ściany ucieka aż 20% - 35% ciepła, a przez dach 15% - 25%.',
        },
        {
            text:
                'Kompleksowa termomodernizacja wraz z optymalizacją systemu grzewczego to najlepszy sposób na ograniczenie kosztów ogrzewania.',
        },
        {
            text: 'Którędy ucieka ciepło?',
            picSrc: 'pics/pic-29.png',
        },
    ],
    powietrzeSection: [
        {
            text:
                'Używaj tylko dozwolonych paliw! Spalanie mułu flotokoncentratu, czy śmieci jest karalne, a do tego emituje olbrzymie ilości szkodliwych dla zdrowia zanieczyszczeń.',
        },
        {
            text:
                'Odnawialne Źródła Energii, takie jak fotowoltaika, kolektory słoneczne, czy pompy ciepła to technologie przyjazne dla środowiska, które jednocześnie pozwalają obniżyć wysokość naszych rachunków.',
        },
        {
            text:
                'Chroń swoje zdrowie i przed wyjściem z domu sprawdzaj jakość powietrza przy pomocy systemu monitoringu powietrza. Wyniki pomiarów dostępne są na stronie <a target="_blank" rel="noopener noreferrer" href="https://atmopolis.pl/dynamic_map/jastrzebie-zdroj.html">https://atmopolis.pl/dynamic_map/jastrzebie-zdroj.html</a>, gdzie stan jakości powietrza jest zwizualizowany za pomocą Dynamicznej Mapy Jakości Powietrza. Mapa dostarcza bieżącą informację oraz prognozy w każdym miejscu miasta!',
        },
        {
            text:
                'Komin Twojego sąsiada kopci? Jesteś świadkiem naruszenia związanego z zaśmiecaniem przestrzeni? Zgłoś to do Eko-Patrolu! Tworzą go pracownicy Straży Miejskiej, dla których zadania z zakresu szeroko rozumianego utrzymania czystości i porządku są zadaniami priorytetowymi.',
        },
        {
            text:
                'Zorientuj się, z jakich źródeł dofinansowania możesz skorzystać. W Jastrzębiu-Zdroju mieszkańcy mogą otrzymać dotację na dofinansowanie kosztów inwestycji z zakresu ochrony środowiska i gospodarki wodnej, w tym do źródeł ciepła. Jest to jedno z najważniejszych działań, jakie realizuje Miasto! Dotacja obejmuje m.in. likwidację pozaklasowego węglowego kotła c.o. i zastąpienie go energooszczędnym kotłem c.o. opalanym gazem, olejem opałowym lub zasilanym energią elektryczną, ogrzewaniem elektrycznym, kotłem c.o. na biomasę oraz kotłem węglowym z automatycznym podajnikiem. Więcej przeczytasz na stronie  <a target="_blank" rel="noopener noreferrer" href="https://www.jastrzebie.pl/ekologia/dotacje/">https://www.jastrzebie.pl/ekologia/dotacje/</a>',
        },
    ],
    wodaSection: [],
    czyWieszSection: [
        {
            text:
                '...w instalacjach kotłowych powstaje ponad 87% emitowanych do atmosfery wielopierścieniowych węglowodorów aromatycznych i ponad 50% dioksyn czy furanów, które charakteryzują się wysoką toksycznością?...',
            more:
                'Ponadto, małe przydomowe kotłownie są przyczyną obecności 65% toksycznego metalu ciężkiego (kadm) oraz 30% ołowiu w powietrzu.',
        },
        {
            text: '...nieocieplony dom z lat 70 zużyje około 200, a nawet 300 kWh/m2/rok?...',
            more:
                'Budynek wybudowany niedawno, zgodnie z obowiązującymi normami, to już zapotrzebowanie znacznie niższe – 80 kWh/rok (pod warunkiem, że został wybudowany przez dobrych i rzetelnych fachowców). Tzw. budynki energooszczędne, a więc bardzo dobrze docieplone, mają jeszcze niższe zapotrzebowanie na energię na potrzeby ogrzewania i wentylacji – około 40 kWh/rok i mniej.',
        },
    ],
};
